import { render, staticRenderFns } from "./kcp-pot.vue?vue&type=template&id=5ad3648d&scoped=true&"
import script from "./kcp-pot.vue?vue&type=script&lang=js&"
export * from "./kcp-pot.vue?vue&type=script&lang=js&"
import style0 from "./kcp-pot.vue?vue&type=style&index=0&id=5ad3648d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3648d",
  null
  
)

export default component.exports